import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_CATEGORY_OPTION, CONTENT_TYPE_TEXT, CONTENT_TYPE_INTERNAL_LINK, CONTENT_TYPE_MAIL_LINK} from '../../constants';

export default {
  id: 'MOD_MAND_DIFF',
  title: 'Comment puis-je diffuser mes documents auprès des autres plateformes ?',
  description: '',
  categories: [CONTENT_CATEGORY_OPTION],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Certains clients vous demandent de mettre à jour vos documents sur les plateformes e-attestation, Provigis, MyProcurement et  AWS... Simplifiez la diffusion de votre dossier en mandatant Attestation Légale pour le faire à votre place grâce au mandat de diffusion*.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Comment le mettre en place ?'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Téléchargez le document'
  },
  {
    type: CONTENT_TYPE_INTERNAL_LINK,
    value: `${pathHelpContentFile}fr/FR_MOD_MAND_DIFF/Mandat de Diffusion.pdf`,
    label: 'en cliquant ici'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Renvoyez le document complété et signé à'
  },
  {
    type: CONTENT_TYPE_MAIL_LINK,
    label: 'service.clients@onceforall.com',
    value: 'mailto:service.clients@onceforall.com'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: ' ',
    value: '\n'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: ' ',
    value: '* option disponible pour les offres Liberté et Horizon. Si vous souhaitez bénéficiez de cette option et qu’elle n’est pas comprise dans votre offre, contactez-nous directement depuis cette page et choisissez la rubrique « Mon Offre ».'
  }]
};
